export enum EOverviewValueSize {
  small = 'small',
  large = 'large',
}

export interface IOverviewBox {
  label: string;
  amount: {
    value: string;
    size: EOverviewValueSize;
  };
  tooltip?: null | string;
}
